import { PDFDocument } from "pdf-lib";

const DPA_PDF_REMOTE_TEMPLATE_URL =
  "https://sanctions-static.s3.eu-west-1.amazonaws.com/templates/contracts/dpa_contract_version_1.0.pdf";
const DPA_PDF_FALLBACK_TEMPLATE_PATH = "/dpa/dpa_contract_version_1.0.pdf";

export async function fetchDpaTemplateBytes(): Promise<Uint8Array> {
  let bytes: Uint8Array;
  try {
    bytes = await fetchPdfBytes(DPA_PDF_REMOTE_TEMPLATE_URL);
  } catch (err) {
    console.warn(
      "Couldn't load the DPA template from S3, falling back to the bundled sample.",
      err,
    );
    bytes = await fetchPdfBytes(DPA_PDF_FALLBACK_TEMPLATE_PATH);
  }
  return withDocumentTitle(bytes, "Data Processing Agreement — sanctions.io");
}

async function fetchPdfBytes(url: string): Promise<Uint8Array> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Couldn't load the DPA template (${res.status})`);
  return new Uint8Array(await res.arrayBuffer());
}

async function withDocumentTitle(bytes: Uint8Array, title: string): Promise<Uint8Array> {
  const pdfDoc = await PDFDocument.load(bytes);
  pdfDoc.setTitle(title);
  return pdfDoc.save();
}
